import {Paper} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {reverse} from 'named-urls';
import React, {useContext, useEffect, useMemo, useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import Notes from '../../../../components/Notes';
import {ServiceContext} from '../../../../components/Services';
import Switched from '../../../../components/Switched';
import Switcher from '../../../../components/Switcher';
import routes from '../../../../routes';

const useStyles = makeStyles((theme) => ({
  container: {
    '&.MuiPaper-root': {
      overflow: 'hidden',
      marginTop: theme.spacing(1),
    }
  }
}));

const Tabs = ({message, onMessageUpdated}) => {
  const services = useContext(ServiceContext);
  const classes = useStyles();
  const match = useRouteMatch();
  const [tab, setTab] = useState('');

  const tabs = useMemo(() => [
    {
      title: 'Notes',
      slug: '',
      path: reverse(routes.inbox.detail, {
        id: message?.id ?? 0
      })
    }
  ], [message]);

  useEffect(() => {
    if (match.params?.tab && tabs.findIndex(t => t.slug) >= 0) {
      setTab(match.params?.tab);
    }
  }, [message, match, tabs])

  return (
    <>
      <Switcher tabs={tabs}/>
      <Paper className={classes.container}>
        <Switched tab="" currentTab={tab}>
          <Notes
            entity={message}
            onEntityUpdated={onMessageUpdated}
            type="message"
            onSave={({comment}) => services.inbox.note.saveNote(message, {comment})}
          />
        </Switched>
      </Paper>
    </>
  );
};

export default Tabs;
